import { render, staticRenderFns } from "./Garra.vue?vue&type=template&id=1bd7d716&scoped=true"
import script from "./Garra.vue?vue&type=script&lang=js"
export * from "./Garra.vue?vue&type=script&lang=js"
import style0 from "./Garra.vue?vue&type=style&index=0&id=1bd7d716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7d716",
  null
  
)

export default component.exports